import { useEffect } from "react";

const DEFAULTS = {
  siteName: "CardMyDog",
  title: "CardMyDog — Turn Your Dog Into a Sports Legend",
  description:
    "Upload a photo of your dog and get a professional AI-generated sports trading card in seconds. Football, basketball, baseball, hockey, soccer. Free preview.",
  image: "https://cardmydog.com/og-image.png",
  url: "https://cardmydog.com",
};

function setMeta(property, content) {
  let el = document.querySelector(`meta[property="${property}"]`) ||
           document.querySelector(`meta[name="${property}"]`);
  if (el) {
    el.setAttribute("content", content);
  }
}

export default function useSEO({ title, description, path } = {}) {
  useEffect(() => {
    const fullTitle = title
      ? `${title} | ${DEFAULTS.siteName}`
      : DEFAULTS.title;
    const desc = description || DEFAULTS.description;
    const pageUrl = path
      ? `${DEFAULTS.url}${path}`
      : DEFAULTS.url;

    document.title = fullTitle;

    setMeta("description", desc);
    setMeta("og:title", fullTitle);
    setMeta("og:description", desc);
    setMeta("og:url", pageUrl);
    setMeta("twitter:title", fullTitle);
    setMeta("twitter:description", desc);
  }, [title, description, path]);
}
